// extracted by mini-css-extract-plugin
export var closeButton = "_hp-2";
export var closeButtonIcon = "_hp-3";
export var lightboxContent = "_hp-1";
export var lightboxOverlay = "_hp-0";